var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightScrollArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40063 6.40039L14.0207 10.9904L9.40063 15.5804",
    stroke: "#666666",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9603 20.98C16.461 20.98 20.9203 16.5073 20.9203 10.99C20.9203 5.4727 16.461 1 10.9603 1C5.45951 1 1.00024 5.4727 1.00024 10.99C1.00024 16.5073 5.45951 20.98 10.9603 20.98Z",
    stroke: "#666666",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightScrollArrow);
export default __webpack_public_path__ + "static/media/right-scroll-arrow.50d248d20ef1fe1f23cc49af139ee822.svg";
export { ForwardRef as ReactComponent };